import React, { useEffect } from 'react';
import { NO_DROP_DOWN } from '../../flows/statements/constants';

interface IProps {
    yearsToDisplay: number[];
    currentYear: number;
    setCurrentYear: (year: number) => void;
    dropdownList?: string[] | null;
    subOptionIndex?: number | null;
    setSubOptionIndex?: React.Dispatch<React.SetStateAction<number>>;
}

const SELECTED_YEAR_CLASSNAME = 'w-full min-h-[60px] font-metricMedium text-bw08  text-[18px]';
const YEAR_CLASSNAME = 'min-h-[60px] text-bw08 font-metricR';

const ACTIVE_SUB_LINK = ' text-action03 border-2 border-action03 rounded cursor-pointer text-bw08';
const INACTIVE_SUB_LINK = ' text-bw08 cursor-pointer';

const YearFilter = ({
  currentYear, setCurrentYear, yearsToDisplay, dropdownList, subOptionIndex, setSubOptionIndex,
}: IProps) => {
  useEffect(() => {
    if (!currentYear && yearsToDisplay.length) {
      setCurrentYear(yearsToDisplay[0]);
    } else {
      setCurrentYear(currentYear);
    }
  }, [currentYear]);

  return (
    <ul className='text-left w-full relative overflow-y-scroll'>
      {yearsToDisplay && yearsToDisplay.length > 0 && yearsToDisplay.map(year => (
        <React.Fragment key={year}>
          <li
            id={`yearFilterSelection${year}`}
            role='presentation'
            className={`${year === currentYear ? SELECTED_YEAR_CLASSNAME : YEAR_CLASSNAME} py-1 cursor-pointer flex flex-col justify-center`}
            onClick={() => {
              setCurrentYear(year);
              if (setSubOptionIndex) {
                setSubOptionIndex(0);
              }
            }}
          >
            {year}
            {year === currentYear && (!dropdownList || dropdownList.length === 0) && subOptionIndex !== NO_DROP_DOWN && <div className='absolute -left-[40px] w-[4px] h-[51px] bg-action03' />}
            <div className='h-fit'>
              {dropdownList && typeof subOptionIndex === 'number' && setSubOptionIndex && year === currentYear && dropdownList.map((link, index) => (
                <React.Fragment key={link}>
                  <span className={(index === 0 && dropdownList.length > 1) ? `absolute mt-[10px] h-[${dropdownList.length * 27}px] text-bw07 border-l-4 border-bw03 rounded` : ''} />
                  <div className={`flex flex-col justify-center ${dropdownList.length - 1 === 0 ? 'py-2' : index === dropdownList.length - 1 ? 'pb-2' : index === 0 ? 'pt-2' : ''}`}>
                    <div
                      id='yearFilterSubSelection'
                      key={link}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        setSubOptionIndex(index);
                      }}
                      role='presentation'
                      className={`h-[27px] relative ${index === (dropdownList.length - 1) ? 'pb-[0.375rem]' : ''}`}
                    >
                      <span className={`absolute h-[27px] ${subOptionIndex === index ? ACTIVE_SUB_LINK : INACTIVE_SUB_LINK}`} />
                      <span
                        className={`cursor-pointer text-base 
                    ${subOptionIndex === index ? 'pl-4 font-metricSemibold text-action03' : 'pl-4 font-metric text-bw06'}`}
                      >
                        {link}
                      </span>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </li>
          {yearsToDisplay.length > 1 && <div className='h-0 border-t border-bw05 border-opacity-50' />}
        </React.Fragment>
      ))}
    </ul>
  );
};
export default YearFilter;
